module.exports = __webpack_public_path__ + "media/images/vp/parallax.temp.05-4c515f1625a12b161187ae5bb7af927e.svg";